import { NoEvents } from '@nv/components'
import EventList from './event_list/EventList'
import styles from './EventsDisplaySection.module.scss'

export const EventsDisplaySection = ({ events, onSelectEvent = (event: any) => {} }) => {
  const eventsPresent = events.active?.length || events.ended?.length || events.upcoming?.length

  return (
    <>
      <div className={styles['container']}>
        {eventsPresent ? (
          <>
            <EventList events={events?.active} status={'Active'} onSelectEvent={onSelectEvent} />
            <EventList events={events?.upcoming} status={'Upcoming'} onSelectEvent={onSelectEvent} />
            <EventList events={events?.ended} status={'Closed'} onSelectEvent={onSelectEvent} />
          </>
        ) : (
          <NoEvents />
        )}
      </div>
    </>
  )
}
